export class LoginModel {
    constructor(
        public user : string,
        public pass : string
    ){ }
}


// WEBPACK FOOTER //
// /app/src/app/shared/models/login.model.ts